import type { TranslationDict } from '../en';

const fr: TranslationDict = {
  'header.buy': 'Acheter',
  'header.sell': 'Vendre',
  'spend.label': 'Vous dépensez',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',
  'receive.label': 'Vous recevez',
  'payment.label': 'Moyen de paiement',
  'payment.select': 'Sélectionner',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'Aucun moyen de paiement pour cette paire',
  'wallet.label': 'Adresse du portefeuille de réception',
  'wallet.placeholderBuy': 'Entrez votre adresse de réception',
  'wallet.placeholderSell': "Entrez votre adresse d'envoi",
  'wallet.validating': "Validation de l'adresse...",
  'wallet.invalid': 'Entrez une adresse de portefeuille valide',
  'wallet.invalidServer': 'Adresse de portefeuille invalide',
  'cta.buy': 'Acheter {crypto}',
  'cta.sell': 'Vendre {crypto}',
  'cta.gettingPrice': 'Recherche du meilleur prix...',
  'cta.processing': 'Traitement...',
  'footer.poweredBy': 'Propulsé par ',
  'footer.brand': 'NowRamp',
  'rate.title': 'Détail du taux',
  'rate.close': 'Fermer',
  'rate.updatesIn': 'Mise à jour du taux dans 00:{seconds}',
  'rate.noQuote': 'Aucune cotation disponible',
  'rate.exchangeRate': 'Taux de change',
  'rate.processingFee': 'Frais de traitement',
  'rate.networkFee': 'Frais de réseau',
  'rate.provider': 'Fournisseur',
  'toast.orderCreated': 'Commande créée',
  'toast.redirecting': 'Redirection vers le paiement...',
  'toast.orderFailed': 'Commande échouée',
  'toast.couldNotCreate': 'Impossible de créer la commande',
  'toast.quoteError': 'Erreur de cotation',
  'toast.noProviders': 'Aucun fournisseur',
  'toast.somethingWrong': "Quelque chose s'est mal passé",
  'error.amountZero': 'Le montant doit être supérieur à 0',
  'error.minAmountFiat': 'Le montant minimum est de {min} {currency}',
  'error.minAmountCrypto': 'Le montant minimum est de {min} {currency}',
  'error.noProviders': 'Aucun fournisseur disponible pour cette combinaison',
  'error.currencyUnavailableBuy': "Cette devise n'est pas disponible pour les achats",
  'error.currencyUnavailableSell': "Cette devise n'est pas disponible pour les ventes",
  'parity.info': 'Vous serez facturé pour {receiveAmount} {crypto}, le reste jusqu\'à {spendAmount} {fiat} sera crédité sur votre compte {partner}',
  'redirect.secureBadge': 'Paiement sécurisé',
  'redirect.title': 'Continuer le paiement',
  'redirect.description': 'Vous serez redirigé vers {gateway} pour finaliser votre paiement.',
  'redirect.countdown': 'Redirection dans {seconds}...',
  'redirect.openTab': 'Ouvrir ACH dans un nouvel onglet',
  'redirect.cancel': 'Annuler',
  'checkout.noOrder': 'Aucune commande trouvée',
  'checkout.goBack': 'Retour',
  'checkout.expired': 'Paiement expiré',
  'checkout.expiredDesc': 'La session a expiré. Veuillez réessayer.',
  'checkout.startOver': 'Recommencer',
  'checkout.cancel': 'Annuler',
  'checkout.loading': 'Chargement du paiement...',
  'checkout.iframeTitle': 'Paiement du fournisseur',
  'checkout.widgetTitle': 'Paiement',
  'checkout.unknownMethod': 'Méthode de paiement inconnue',
  'processing.default': 'Traitement de votre commande...',
  'processing.pending': 'En attente de la confirmation du paiement...',
  'processing.active': 'Traitement de votre transaction...',
  'processing.generic': 'Traitement...',
  'processing.checkingStatus': 'Vérification du statut...',
  'processing.orderId': 'ID de commande',
  'processing.provider': 'Fournisseur',
  'processing.amount': 'Montant',
  'processing.receiving': 'Réception',
  'processing.network': 'Réseau',
  'processing.toAddress': 'Adresse de destination',
  'processing.usuallyMinutes': 'Cela prend généralement quelques minutes.',
  'processing.safeToClose': 'Vous pouvez fermer cette page en toute sécurité - nous vous enverrons un e-mail une fois terminé.',
  'complete.buyTitle': 'Achat terminé !',
  'complete.sellTitle': 'Vente terminée !',
  'complete.buyDesc': 'Vos {crypto} ont été envoyés vers votre portefeuille.',
  'complete.sellDesc': 'Votre paiement en {fiat} est en cours de traitement.',
  'complete.amountBuy': 'Montant reçu',
  'complete.amountSell': 'Montant vendu',
  'complete.paidBuy': 'Montant payé',
  'complete.paidSell': 'Montant du versement',
  'complete.network': 'Réseau',
  'complete.wallet': 'Portefeuille',
  'complete.transaction': 'Transaction',
  'complete.provider': 'Fournisseur',
  'complete.orderId': 'ID de commande',
  'complete.completed': 'Terminé',
  'complete.viewExplorer': "Voir sur l'explorateur",
  'complete.done': 'Terminé',
  'errorStep.failed': 'Paiement échoué',
  'errorStep.cancelled': 'Commande annulée',
  'errorStep.expired': 'Commande expirée',
  'errorStep.refunded': 'Commande remboursée',
  'errorStep.unknown': "Quelque chose s'est mal passé",
  'errorStep.failedBuy': "Votre paiement n'a pas pu être traité. Veuillez réessayer ou utiliser un autre moyen de paiement.",
  'errorStep.failedSell': "Votre vente n'a pas pu être traitée. Veuillez réessayer.",
  'errorStep.cancelledBuy': 'Votre commande a été annulée. Aucun paiement n\'a été effectué.',
  'errorStep.cancelledSell': 'Votre vente a été annulée. Aucune crypto n\'a été transférée.',
  'errorStep.expiredBuy': 'Votre commande a expiré. Veuillez effectuer un nouvel achat.',
  'errorStep.expiredSell': 'Votre commande a expiré. Veuillez effectuer une nouvelle vente.',
  'errorStep.refundedBuy': 'Votre paiement a été remboursé. Les fonds apparaîtront sur votre compte sous 5 à 10 jours ouvrables.',
  'errorStep.refundedSell': 'Vos cryptos ont été restituées. Les fonds apparaîtront dans votre portefeuille sous peu.',
  'errorStep.genericDesc': 'Une erreur inattendue est survenue. Veuillez réessayer.',
  'errorStep.orderId': 'ID de commande',
  'errorStep.tryAgain': 'Réessayer',
  'errorStep.startOver': 'Recommencer',
  'errorStep.return': 'Retour',
  'errorStep.needHelp': "Besoin d'aide ? Contactez ",
  'errorStep.reference': 'Référence : {orderId}',
  'confirm.buyTitle': "Confirmer l'achat",
  'confirm.sellTitle': 'Confirmer la vente',
  'confirm.loading': 'Chargement...',
  'confirm.provider': 'Fournisseur',
  'confirm.youPay': 'Vous payez',
  'confirm.youSell': 'Vous vendez',
  'confirm.youReceive': 'Vous recevez',
  'confirm.wallet': 'Portefeuille',
  'confirm.network': 'Réseau',
  'confirm.refundAddress': 'Adresse de remboursement',
  'confirm.parityNote': 'Le montant facturé par le fournisseur peut différer. Le reste jusqu\'à {amount} {crypto} sera crédité sur votre compte {partner}.',
  'confirm.processing': 'Traitement...',
  'confirm.confirmPay': 'Confirmer et payer',
  'confirm.confirmSell': 'Confirmer et vendre',
  'confirm.payout': 'Versement en {currency}',
  'modal.selectFiat': 'Sélectionner une devise fiat',
  'modal.selectCrypto': 'Sélectionner une cryptomonnaie',
  'modal.choosePayment': 'Choisir un moyen de paiement',
  'modal.selectCountry': 'Sélectionnez votre pays',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'Populaire',
  'modal.recommended': 'Recommandé',
  'modal.noCurrencies': 'Aucune devise trouvée',
  'modal.noPaymentMethods': 'Aucun moyen de paiement trouvé',
  'modal.noCountries': 'Aucun pays trouvé',
  'modal.noLanguages': 'No languages found',
  'settings.location': 'Localisation',
  'settings.darkMode': 'Mode sombre',
  'settings.privacy': 'Politique de confidentialité',
  'settings.terms': "Conditions d'utilisation",
  'settings.language': 'Langue',
  // ─── Additional ───
  'modal.chooseRamp': 'Choisir Ramp',
  'modal.bestPrice': 'Meilleur prix',
  'modal.noQuotes': 'Aucune cotation disponible pour cette demande',
  'modal.noProvidersFound': 'Aucun fournisseur trouvé',
  'payment.unavailableFor': 'Aucun moyen de paiement disponible pour {currency}',
  'skeleton.poweredBy': 'Propulsé par NowRamp',
  'error.createOrderFailed': 'Échec de la création de la commande',
  'errorStep.returnToMerchant': 'Retour au marchand',
  'confirm.cryptoOnNetwork': '{crypto} sur {network}',
  'payment.name.card': 'Carte',
  'payment.name.bankTransfer': 'Virement bancaire',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default fr;
